import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './containers/Home';
import Layout from './containers/Layout';
import './App.css';
import './assets/style/index.scss';
import "animate.css";

export const APIurl = "https://eatrade.co.za/API.php"; 

//export const APIurl = "http://localhost/eatradeAPI/API.php";
//export const BaseIurl = "http://localhost/eatradeAPI/";
export const BaseIurl = "https://eatrade.co.za/";

//eslint-disable-next-line no-restricted-globals 
  var BaseURL = location.href;
                BaseURL = BaseURL.split("/");
                BaseURL = BaseURL[0] + BaseURL[1] + "//"+ BaseURL[2];
export const rootUrl = BaseURL;

export function callcookie(name,value,days){

  if(days){

      var d =  new Date();

      d.setTime(d.getTime()+(days*24*60*60*1000));

      var expires = "; expires=" + d.toGMTString();

  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; ";
}

export function deletecookie(name){

  document.cookie = name+"= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
 }
 
export function getCookie(name) {
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); 
  return match ? match[1] : null;
}

function App() {
  return (
    <Layout/>
    );
}

export default App;
